import { Box, Flex } from "@chakra-ui/react";
import ModalHeaderComponent from "../../../../../components/Common/ModalHeaderComponent";
import i18n from "../../../../../i18n/i18n";
import { useEffect, useState } from "react";
import { User } from "../../../../../definitions/interfaces/Users/Users.interface";
import { getAllInvitationsToTeam } from "../../../../../models/TeamModel";
import { appStore } from "../../../../../zustand/globalStore";
import { stepsTournaments } from "../../../../../definitions/constants/GlobalConstants";
import { colors } from "../../../../../definitions/constants/GlobalStyles";
import BodyText from "../../../../../components/Common/BodyText";
import ItemRequest from "../../../../../pages/tournaments/teams/Options/Managers/components/ItemRequest";
import SpinnerComponent from "../../../../../components/Common/SpinnerComponent";

const RequestsSent = ({
  goToStep,
}: {
  goToStep: (key: string) => void;
}): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const [teams, setTeams] = useState<User[]>([]);
  const { currentTeam, hideContainerModal } = appStore((store) => store);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const findTeams = await getAllInvitationsToTeam(currentTeam.id);
      setTeams(findTeams);
      setLoading(false);
    })();
  }, [currentTeam.id]);

  return (
    <Flex flexDirection="column" width="100%" height="100%">
      {loading && <SpinnerComponent spinnerKey="modal" />}
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        gap={4}
      >
        <ModalHeaderComponent
          title={i18n.t("applicationSent")}
          subtitle={i18n.t("readyTournament")}
          onCancel={hideContainerModal}
          onBack={() => goToStep(stepsTournaments.optionsSeason)}
          isSaving={loading}
          hasMoreSteps={true}
          actionButtonsRequired={false}
        />
        <Flex
          flexDirection="column"
          flexGrow={1}
          overflowY="auto"
          css={{
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "scrollbar-width": "none",
          }}
        >
          {teams.length > 0 ? (
            teams.map((item) => <ItemRequest item={item} setUsers={setTeams} />)
          ) : (
            <BodyText
              fontSize={{ base: "11px", md: "12px" }}
              fontWeight="semiBold"
              textColor={colors.text.black}
            >
              {i18n.t("noData")}
            </BodyText>
          )}
        </Flex>
      </Box>
    </Flex>
  );
};

export default RequestsSent;
